import React, { useState, useEffect } from 'react';
import { Button,  TextField, InputLabel, Typography } from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import configParam from '../../config';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "axios";



const filter = createFilterOptions();
function AddPlant({ open, onClose, onSave, selectedRowPlantData: selectedRowPlantDataProp, selectedRowData, selectedPlantCardData,addedAreas,onHandleArea,onShowAlertMessage,userDet }) {
  // Accept either prop name so an edit is never mistaken for a new plant
  const selectedRowPlantData = selectedRowPlantDataProp || selectedRowData || null;
  const [business, setBusiness] = useState(null);
  const [category, setCategory] = useState(null);
  const [tabledata, setTableData] = useState([]);
  const [plantdata, setPlantData] = useState([]);
  const [businessdata, setBusinessData] = useState([]);
  const [categorydata, setCategoryData] = useState([]);
  const [location, setLocation] = useState(null);
  const [locationdata, setLocationData] = useState([]);
  const [plant, setPlant] = useState(null);
  const [inputPlant, setInputPlant] = useState(null);
  const [inputValuePlant, setInputValuePlant] = useState('');
  const [isInputValuePlantInitialized, setInputValuePlantInitialized] = useState(false);
  const [isCursorInsideDialog, setIsCursorInsideDialog] = useState(false);
  const [access_token,setAccessToken]=useState(localStorage.getItem("accesstoken"))
  const [formError, setFormError] = useState({ business: '', location: '', plant: '', category: '' });
  const ApiURL = configParam.API_URL;
  const selectedLocationName = locationdata.find((option) => option.id === location)?.location;
  const filteredPlantOptions = plantdata.filter((option) => {
    const optionLocationId = option.location_id ?? option.locationId ?? null;
    const optionLocationName = (option.location || '').toLowerCase();
    if (!location) return true;
    return optionLocationId === location || optionLocationName === (selectedLocationName || '').toLowerCase();
  });

  const normalizeName = (name) => (name || '').trim().toLowerCase();
  const editingPlantId = selectedRowPlantData?.id || selectedPlantCardData?.id || null;
  const matchesSelectedLocation = (option) => {
    const optionLocationId = option.location_id ?? option.locationId ?? null;
    const optionLocationName = (option.location || '').toLowerCase();
    return optionLocationId === location || optionLocationName === (selectedLocationName || '').toLowerCase();
  };
  // Show each plant only once in the dropdown (prefer the record currently being edited)
  const uniquePlantOptions = filteredPlantOptions.reduce((acc, option) => {
    const key = normalizeName(option.plantName);
    if (!key) return acc;
    const index = acc.findIndex((item) => normalizeName(item.plantName) === key);
    if (index === -1) {
      acc.push(option);
    } else if (editingPlantId && option.id === editingPlantId) {
      acc[index] = option;
    }
    return acc;
  }, []);
  // Identify an already-existing plant (by id, or by name within the selected location)
  const findExistingPlant = (candidate) => {
    if (!candidate) return null;
    if (candidate.id) {
      return plantdata.find((option) => option.id === candidate.id) || candidate;
    }
    const key = normalizeName(candidate.plantName);
    if (!key) return null;
    const matches = plantdata.filter(
      (option) => normalizeName(option.plantName) === key && (!location || matchesSelectedLocation(option))
    );
    return matches.find((option) => option.id === editingPlantId) || matches[0] || null;
  };

  const modalInputLabelStyle = {
 
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 500,
    color: '#000',
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getPlantAsyncDetails();
        setPlantData(response.data);
      } catch (error) {
        setPlantData([]);
      }
    };
  
    fetchData();
  }, [selectedRowPlantData,selectedPlantCardData]);
  
  useEffect(() => {
    if (selectedRowPlantData && plantdata.length > 0) {
      // If selectedRowData is present, it's an edit operation
      const selectedBusiness = businessdata.find((option) => option.business_name.toLowerCase() === selectedRowPlantData.business.toLowerCase());
      const selectedLocation = locationdata.find((option) =>option.location.toLowerCase() === selectedRowPlantData.location.toLowerCase());
      
      const selectedPlant = plantdata.find((option) => option.id === selectedRowPlantData.id)
        || plantdata.find((option) => option.plantName.toLowerCase() === selectedRowPlantData.plant.toLowerCase());
      const selectedCategory = categorydata.find((option) => option.name === selectedRowPlantData.category);
    
      setBusiness(selectedBusiness ? selectedBusiness.id : null);
      setLocation(selectedLocation ? selectedLocation.id : null)
      setPlant(selectedPlant ? selectedPlant:null);
      setCategory(selectedCategory?selectedCategory.id:null);
  
    }
    else if (selectedPlantCardData && plantdata.length > 0) {
     
      // If selectedRowData is present, it's an edit operation
      const selectedBusiness = businessdata.find((option) => option.business_name.toLowerCase() === selectedPlantCardData.business_name.toLowerCase());
      const selectedLocation = locationdata.find((option) => option.location.toLowerCase() === selectedPlantCardData.location.toLowerCase());
      const selectedPlant = plantdata.find((option) => option.id === selectedPlantCardData.id)
        || plantdata.find((option) => option.plantName.toLowerCase() === selectedPlantCardData.plantName.toLowerCase());
      const selectedCategory = categorydata.find((option) => option.name=== selectedPlantCardData.category_name);
     
      setBusiness(selectedBusiness ? selectedBusiness.id : null);
      setLocation(selectedLocation ? selectedLocation.id : null)
      setPlant(selectedPlant ? selectedPlant:null);
      setCategory(selectedCategory?selectedCategory.id:null);
    }
    else {
      // If selectedRowData is null, it's an add operation
      setBusiness(null);
      setLocation(null);
      setPlant(null);
      setInputValuePlant(null);
      setCategory(null);
     
    }
 

  }, [selectedRowPlantData,selectedPlantCardData,plantdata]);

  useEffect(() => {
    // Function to check for accessToken changes
    const handleAccessTokenChange = () => {
      const storedAccessToken = localStorage.getItem("accesstoken");
      if (storedAccessToken !== access_token) {
        setAccessToken(storedAccessToken);
      }
    };
  
    // Listen for storage events (for cross-tab changes)
    window.addEventListener("storage", handleAccessTokenChange);
  
    // Check for changes every second (for same-tab changes)
    const interval = setInterval(handleAccessTokenChange, 1000);
  
    // Cleanup listeners and interval on component unmount
    return () => {
      window.removeEventListener("storage", handleAccessTokenChange);
      clearInterval(interval);
    };
  }, [access_token]); // Dependency on accessToken
 
  useEffect(() => {
    getPlantDetails();
    getBusinessDetails();
    getLocationDetails();
    getCategoryDetails();
  }, []);

  const getPlantDetails = () => {
    let url = ApiURL + '/show_plant';
    axios.get(url,{
      headers: {
        Authorization: `Bearer ${access_token}`,
       
      }
    }
  ).then((response) => {
      setTableData(response.data);
    }).catch((error) => {
      setTableData([]);
    });
  };
  const getPlantAsyncDetails = async () => {
    let url = ApiURL + '/show_plant';
  return await axios.get(url,{
    headers: {
      Authorization: `Bearer ${access_token}`,
     
    }
  }
);
  };
  const getBusinessDetails = () => {
    let url = ApiURL + '/show_business';
    axios.get(url,{
      headers: {
        Authorization: `Bearer ${access_token}`,
       
      }
    }
  ).then((response) => {
      setBusinessData(response.data);
    }).catch((error) => {
      setBusinessData([]);
    });
  };
  const getCategoryDetails = () => {
    let url = ApiURL+'/show_category';
    axios.get(url,{
      headers: {
        Authorization: `Bearer ${access_token}`,
       
      }
    }
  ).then((response) => {
    setCategoryData(response.data);
    }).catch((error) => {
      setCategoryData([]);
    });
  };
  const getLocationDetails = () => {
    let url = ApiURL + '/show_location';
    axios.get(url,{
      headers: {
        Authorization: `Bearer ${access_token}`,
       
      }
    }
  ).then((response) => {
      setLocationData(response.data);
    }).catch((error) => {
      setLocationData([]);
    });
  };

  const handleClose = () => {
    setBusiness(null);
    setLocation(null);
    setPlant(null);
    setInputValuePlant(null);
    setInputPlant('');
    setCategory(null);
    setFormError({ business: '', location: '', plant: '', category: '' });
    setInputValuePlantInitialized(false);
    onClose();
  };

  const handleBusinessChange = (event, newValue) => {
    setBusiness(newValue ? newValue.id : null);
    setFormError((prev) => ({ ...prev, business: '' }));
  };
  const handleCategoryChange = (event, newValue) => {
    setCategory(newValue ? newValue.id : null);
    setFormError((prev) => ({ ...prev, category: '' }));
  };
  const normalizePlantValue = (option) => {
    if (!option) return null;
    if (typeof option === 'string') return { id: null, plantName: option };
    if (option.inputValue) return { id: null, plantName: option.inputValue };
    return option;
  };

  const handleLocationChange = (event, newValue) => {
    const nextLocationId = newValue ? newValue.id : null;
    const nextLocationName = newValue ? (newValue.location || '').toLowerCase() : '';
    setLocation(nextLocationId);
    setFormError((prev) => ({ ...prev, location: '' }));

    const isPlantInSelectedLocation = (item) => {
      if (!item || !nextLocationId) return true;
      const normalizedItem = normalizePlantValue(item);
      if (!normalizedItem || !normalizedItem.id) return true;
      const itemLocationId = normalizedItem.location_id ?? normalizedItem.locationId ?? null;
      const itemLocationName = (normalizedItem.location || '').toLowerCase();
      return itemLocationId === nextLocationId || itemLocationName === nextLocationName;
    };

    if (plant && !isPlantInSelectedLocation(plant)) {
      setPlant(null);
      setFormError((prev) => ({ ...prev, plant: 'Please select a plant for the selected location' }));
    }
  };
 
  
  const handleSave = () => {
    const normalizedPlant = normalizePlantValue(plant);
    const selectedPlantValue = normalizedPlant || (inputValuePlant && inputValuePlant.plantName ? { id: inputValuePlant.id, plantName: inputValuePlant.plantName } : null);
    // Reuse an existing plant instead of inserting / renaming into a duplicate
    const existingPlant = findExistingPlant(selectedPlantValue);
    const typedPlantName = selectedPlantValue && selectedPlantValue.plantName ? selectedPlantValue.plantName : (inputPlant || '');
    const nextPlantName = existingPlant && existingPlant.plantName ? existingPlant.plantName : (typedPlantName || '').trim();
    // Editing -> always update the row being edited (with the selected / typed plant name);
    // adding -> reuse the existing plant record if one was picked, otherwise create a new one
    const plantId = selectedRowPlantData?.id || selectedPlantCardData?.id || existingPlant?.id || null;
    const newArea = plantId
      ? {
          id: plantId,
          plant: plantId,
          business: business ? business : '',
          location: location ? location : '',
          plantName: nextPlantName,
          userdet: userDet.id,
          category: category ? category : '',
        }
      : {
          business: business ? business : '',
          location: location ? location : '',
          plant: '',
          plantName: nextPlantName,
          inputPlant: nextPlantName,
          userdet: userDet.id,
          category: category ? category : '',
        };
    const validationErrors = {
      business: !business ? 'Please select a business' : '',
      location: !location ? 'Please select a location' : '',
      plant: !nextPlantName ? 'Please enter a plant name' : '',
      category: !category ? 'Please select a category' : '',
    };
    setFormError(validationErrors);
    if (Object.values(validationErrors).some(Boolean)) return;
    if (plantId) {
      axios
        .post(ApiURL + '/update_plant', newArea,{
          headers: {
            Authorization: `Bearer ${access_token}`,
           
          }
        }
      )
        .then((response) => {
          onSave(newArea);
          onHandleArea();
          onShowAlertMessage('Plant updated successfully');
         
        })
        .catch((error) => {
          console.error('Failed to save area:', error);
          if (error?.response?.status === 409) {
            onShowAlertMessage('Plant already exists in this location');
          }
        });
    } else {
      axios
        .post(ApiURL + '/create_plant', newArea,{
          headers: {
            Authorization: `Bearer ${access_token}`,
            
          }
        }
      )
        .then((response) => {
          onSave(newArea);
          onHandleArea();
          onShowAlertMessage('Plant created successfully');
         
        })
        .catch((error) => {
          console.error('Failed to save area:', error);
        });
    }
    setBusiness(null);
    setLocation(null);
    setPlant(null);
    setInputValuePlant(null);
    setInputPlant('');
    setCategory(null);
    setFormError({ business: '', location: '', plant: '', category: '' });
  }
    
  const handleInputChange = (event, newInputValue) => {
    setInputValuePlant({ id: inputValuePlant?.id || null, plantName: newInputValue });
    setInputPlant(newInputValue);
  };

 
  
  const renderPlantField = () => {
    return (
      <div>
        <Autocomplete
          className="autocomplete-nis"
          size="small"
          freeSolo
          value={normalizePlantValue(plant)}
          onChange={(event, newValue) => {
            const normalizedValue = findExistingPlant(normalizePlantValue(newValue)) || normalizePlantValue(newValue);
            setPlant(normalizedValue);
            setInputPlant(normalizedValue?.plantName || '');
            setFormError((prev) => ({ ...prev, plant: '' }));
          }}
          inputValue={inputPlant || ''}
          onInputChange={(event, newInputValue) => {
            setInputPlant(newInputValue);
            if (!newInputValue) {
              setPlant(null);
            }
          }}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            if (params.inputValue.trim() !== '' && !filtered.some((option) => {
              const candidate = normalizePlantValue(option);
              return candidate && candidate.plantName && candidate.plantName.toLowerCase() === params.inputValue.trim().toLowerCase();
            })) {
              filtered.push({
                inputValue: params.inputValue,
                title: `Add "${params.inputValue.trim()}"`,
              });
            }
            return filtered;
          }}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          id="my-autocomplete"
          options={uniquePlantOptions}
          getOptionLabel={(option) => {
            if (typeof option === 'string') {
              return option;
            }
            if (option && option.inputValue) {
              return option.inputValue;
            }
            return option && option.plantName ? option.plantName.toUpperCase() : '';
          }}
          renderOption={(props, option) => (
            <li {...props}>
              {option && option.inputValue ? `Add "${option.inputValue}"` : option && option.plantName ? option.plantName.toUpperCase() : ''}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              fullWidth
              error={!!formError.plant}
              helperText={formError.plant}
            />
          )}
          style={{ marginBottom: 16 }}
        />
      </div>
    );
  }


  return (
    <div >
    <Dialog open={open} onClose={handleClose} fullWidth   maxWidth="xs">
     
     
        <DialogTitle style={{  paddingBottom: 0 }}>Plant Details</DialogTitle>
        <DialogContent  className={`dialog-content ${isCursorInsideDialog ? 'show-scroll' : ''}`}

     

onMouseEnter={() => {

  setIsCursorInsideDialog(true);

}}

onMouseLeave={() => {

  setIsCursorInsideDialog(false);

}}>
        <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5 }}>Business</Typography>
        <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5 }}>Business<span style={{ color: 'red' }}> *</span></Typography>
        <Autocomplete
          className="autocomplete-nis"
          size="small"
          options={businessdata}
          getOptionLabel={(newValue) => newValue.business_name.toUpperCase()}
          onChange={handleBusinessChange}
          value={businessdata.find((option) => option.id === business) || null}
          renderInput={(params) => <TextField {...params} fullWidth error={!!formError.business} helperText={formError.business} />}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          style={{ marginBottom:16}}
        />
        
        <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5, mt: 1.5 }}>Location<span style={{ color: 'red' }}> *</span></Typography>
        <Autocomplete
          className="autocomplete-nis"
          size="small"
          options={locationdata}
          getOptionLabel={(newValue) => newValue.location.toUpperCase()}
          onChange={handleLocationChange}
          value={locationdata.find((option) => option.id === location) || null}
          renderInput={(params) => <TextField {...params} fullWidth error={!!formError.location} helperText={formError.location} />}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          style={{ marginBottom:16}}
        />
        <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5, mt: 1.5 }}>Plant<span style={{ color: 'red' }}> *</span></Typography>
      {renderPlantField()}
      <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5, mt: 1.5 }}>Category<span style={{ color: 'red' }}> *</span></Typography>
        <Autocomplete
          className="autocomplete-nis"
          size="small"
          options={categorydata}
          getOptionLabel={(newValue) => newValue.name}
          onChange={handleCategoryChange}
          value={categorydata.find((option) => option.id === category) || null}
          renderInput={(params) => <TextField {...params} fullWidth error={!!formError.category} helperText={formError.category} />}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          style={{ marginBottom:16}}
        />
       
        </DialogContent>
        <DialogActions style={{ borderTop: '1px solid #f5f5f5', padding: '10px 20px' }}>
          <Button variant="outlined" onClick={handleClose} style={{ color: '#203468', marginRight: '8px', borderColor: '#203468' }}>
            Cancel
          </Button>
          <Button variant="contained" style={{ backgroundColor: '#203468' }} onClick={handleSave}>
            Save
          </Button>
          </DialogActions>
       
      
    </Dialog>
    </div>
  );
}

export default AddPlant;